<template>
    <div class="count-chip" @click="folded =!folded">
        <template v-if="fields.length === 0">
            <small><i>{{$t('instance.query_fields.model_fields_display.empty_text')}}</i></small>
        </template>
        <div v-else style="display: flex; align-items: center;">
            <div>
                {{ fields[0]}}
                <div v-if="fields.length > 1 && !folded">
                    <template v-for="(item, index) in fields">
                        <template v-if="index !== 0">
                            <div :key="item" style="margin-top: 4px">
                                {{ item }}
                            </div>
                        </template>
                    </template>
                </div>
            </div>
            <template v-if="fields.length > 1">
                <v-chip small>
                    <template v-if="fields.length > 1 && !folded">-</template>
                    <template v-else>+{{ fields.length - 1}}</template>
                </v-chip>
            </template>
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        fields: {
            type: Array,
            required: true,
        },
    },

    data (){
        return {
            folded: true,
        };
    },

    computed: {
    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
.count-chip .v-chip__content{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/QueryFields/model-fields-display.vue